export const TransfersEndpoints = {
  getTransfersList: 'getTransfersList',
  getTransfersListInf: 'getTransfersListInf',
} as const;

export const TransfersTags = {
  transfers: 'transfers',
} as const;

export const BASE_TRANSFERS_URL = '/v1/products/transfers';
export const TRANSFER_ID_URL = `${BASE_TRANSFERS_URL}/:id`;
